export const invertUserLevel = {
    admin: 'user',
    user: 'admin'
}

export const GROUP_HIERARCHY = ["groguru", "distributor", "dealer", "business"];
export const GROUP_HIERARCHY_DEALER = ["groguru", "distributor", "dealer", "business", "member"];